import React, { memo, useCallback } from 'react'

import {
  func, number, string, oneOfType, bool,
} from 'prop-types'

// The whole card is a single button: clicking anywhere triggers the remix
// action, keeping one focusable control (no nested interactives) for keyboard
// and screen-reader users.
function Card({
  id,
  slug = '',
  title,
  prompt,
  createdAt,
  image,
  onRemix,
  eager = false,
}) {
  const handleRemix = useCallback(() => {
    // Pass the full surface area the downstream optimistic library entry and
    // viewer placeholder need; Card stays the only place that knows the field
    // names the BE returns. `slug` drives the stable detail URL.
    onRemix({ id, slug, title, prompt, createdAt, image })
  }, [onRemix, id, slug, title, prompt, createdAt, image])

  return (
    <button
      type="button"
      className="community-gallery-card"
      onClick={handleRemix}
      aria-label={`Remix ${title}`}
    >
      <img
        className="community-gallery-card__image"
        src={image}
        alt=""
        aria-hidden="true"
        loading={eager ? 'eager' : 'lazy'}
        decoding="async"
        fetchpriority={eager ? 'high' : 'low'}
      />

      {/* Hidden for now until we implement liking/commenting in models */}
      {/* <span className="community-gallery-card__stats">
        <span className="community-gallery-card__stat">
          <Icon svgComponent={Chat2} size={iconSizeMedium} color="dark" notSpaced />
          <span className="community-gallery-card__stat-count cgt-body-base-semibold">{commentsCount}</span>
        </span>
        <span className="community-gallery-card__stat">
          <Icon svgComponent={Like2} size={iconSizeMedium} color="dark" notSpaced />
          <span className="community-gallery-card__stat-count cgt-body-base-semibold">{likeCount}</span>
        </span>
      </span> */}
    </button>
  )
}

Card.propTypes = {
  id: oneOfType([number, string]).isRequired,
  slug: string,
  title: string.isRequired,
  prompt: string.isRequired,
  createdAt: string.isRequired,
  image: string.isRequired,
  onRemix: func.isRequired,
  eager: bool,
}

export default memo(Card)
